import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { FormikErrors, useFormikContext } from 'formik';

function isObject(val: FormikErrors<unknown>) {
	if (val === null) {
		return false;
	}
	return typeof val === 'function' || typeof val === 'object';
}

const getFirstErrorKey = (object: FormikErrors<unknown>, keys: string[] = []): string => {
	const firstErrorKey = Object.keys(object)[0];
	if (isObject(object[firstErrorKey as keyof object])) {
		return getFirstErrorKey(object[firstErrorKey as keyof object], [...keys, firstErrorKey]);
	}
	return firstErrorKey;
};

const ScrollToError: FC<PropsWithChildren> = ({ children }) => {
	const formik = useFormikContext();
	const [submitCount, setSubmitCount] = useState(formik.submitCount);
	useEffect(() => {
		if (!formik.isValid && formik.submitCount > submitCount) {
			let firstErrorKey = getFirstErrorKey(formik.errors);
			if (firstErrorKey === 'line1') {
				firstErrorKey = 'houseNameOrNumber';
			}
			if (document.getElementsByName(firstErrorKey).length) {
				let index = 0;
				if (Object.keys(formik.errors)[0] === 'overnightAddress') {
					index = document.getElementsByName(firstErrorKey).length - 1;
				}
				const errorElement = document.getElementsByName(firstErrorKey)[index];
				if (errorElement) {
					try {
						errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
						errorElement.focus({ preventScroll: true });
					} catch (e) {
						console.error('error', e);
					}
				}
			}
			setSubmitCount(formik.submitCount);
		}
	}, [formik.submitCount, formik.isValid, formik.errors, submitCount]);

	return children as React.ReactElement;
};

export default ScrollToError;
